var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "grounding-row", class: "is-" + _vm.grounding },
    [
      _c(
        "span",
        { staticClass: "grounding-chip", attrs: { title: _vm.hint } },
        [
          _c("i", { class: _vm.iconClass }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.text))]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }